import { render } from "./generateLicensedPdfOth.vue?vue&type=template&id=5af46208"
import script from "./generateLicensedPdfOth.vue?vue&type=script&lang=js"
export * from "./generateLicensedPdfOth.vue?vue&type=script&lang=js"

import "./generateLicensedPdfOth.vue?vue&type=style&index=0&id=5af46208&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__